:host {
  position: relative;
}

.wrapper {
  flex-direction: column;
  height: 100%;
}

.header {
  padding: calc(2 * var(--spacer));
}

.content {
  display: flex;
  align-items: stretch;
  height: 100%;
}

.header-buttons {
  margin-bottom: calc(2 * var(--spacer));
}

.header-buttons {
  .grid-title-tooltip {
    flex: 0.8;
    padding-top: calc(var(--spacer) - 4px);
  }

  .grid-title {
    display: inline;
  }

  .changelog-link {
    flex: 0.2;
    text-align: center;
  }

  .subtitle-info-text {
    color: var(--body-text-arrows-400);
  }
}

::part(gridGlobalActions) {
  height: auto;
}

::part(gridToolbar) {
  display: none;
}
